/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowsOutLineHorizontal(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM96,120H56V96a8.00066,8.00066,0,0,0-13.65723-5.65723l-32,32a8.00122,8.00122,0,0,0,0,11.31446l32,32A8.00066,8.00066,0,0,0,56,160V136H96a8,8,0,0,0,0-16Zm149.65723,2.34277-32-32A8.00066,8.00066,0,0,0,200,96v24H160a8,8,0,0,0,0,16h40v24a8.00053,8.00053,0,0,0,13.65723,5.65723l32-32A8.00122,8.00122,0,0,0,245.65723,122.34277Z" />
    </Svg>
  );
}

export default ArrowsOutLineHorizontal;
